import jwt_decode from 'jwt-decode';
import { splitLocationString } from '../../../util/index';
import { AccessToken, AccessTokenJwt } from '../../models/index';
import { UseCase } from '../UseCase';

export class DecodeAccessToken implements UseCase<string, AccessToken> {
    execute(token: string): AccessToken {
        const map = splitLocationString(token);
        if (map.access_token) {
            token = map.access_token;
        }

        return {
            token,
            jwt: jwt_decode<AccessTokenJwt>(token)
        };
    }
}
